<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-box-body">
        <el-table class="filterTable" :data="tableData" size="small" border style="width: 100%"
                  header-row-class-name="table-header">
          <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
          <el-table-column prop="masterName" label="项目名" width="180" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.id === 15">
                {{scope.row.masterName}}
                （<input type="number" v-model="projectPricemonth" style="width:40px; border:none;border-bottom:1px solid #c4c4c4; text-align: center; color: #333;">个月）
              </div>
              <div v-else>{{scope.row.masterName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="促销员库" align="center">
            <el-table-column :label="item.id === 0 ? '全部人员' : item.signName" align="center" v-for="item in signNameList"
                             :key="item.id">
              <template slot-scope="scope">
                <div v-for="(config, index) in configList" :key="index"
                     v-if="config.conditionId === scope.row.id && config.postId === item.id && config.webId === 1"
                     class="checked" @click="check('remove', scope.row.id, item.id, 1)">
                  <img src="../../common/images/icon-checked.png" alt="">
                  已选择
                </div>
                <div v-if="
                  (scope.row.id === 11 && item.id === 1) ||
                  (scope.row.id === 12 && item.id === 2) " class="disabled">
                  <img src="../../common/images/icon-disabled.png" alt="">
                  已禁用
                </div>
                <div @click="check('add', scope.row.id, item.id, 1)" class="default">
                  <img src="../../common/images/icon-circle.png" alt="">
                  请选择
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="基础中心" align="center">
            <el-table-column :label="item.id === 0 ? '全部人员' : item.signName" align="center" v-for="item in signNameList"
                             :key="item.id">
              <template slot-scope="scope">
                <div v-for="(config, index) in configList" :key="index"
                     v-if="config.conditionId === scope.row.id && config.postId === item.id && config.webId === 2"
                     class="checked" @click="check('remove', scope.row.id, item.id, 2)">
                  <img src="../../common/images/icon-checked.png" alt="">
                  已选择
                </div>
                <div v-if="
                  (scope.row.id === 11 && item.id === 1) ||
                  (scope.row.id === 12 && item.id === 2)" class="disabled">
                  <img src="../../common/images/icon-disabled.png" alt="">
                  已禁用
                </div>
                <div @click="check('add', scope.row.id, item.id, 2)" class="default">
                  <img src="../../common/images/icon-circle.png" alt="">
                  请选择
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="save-button">
          <el-button type="primary" v-if="auths.indexOf(2) > -1" size="mini" round @click="save">确认选择</el-button>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
  import utils from '../../common/js/util'

  export default {
    data() {
      return {
        tableData: [],
        signNameList: [
          {
            "id": 1,
            "signName": "长促销",
            "signType": 2,
            "pid": null,
            "signLevel": null,
            "signHot": null
          },
          {
            "id": 2,
            "signName": "短促销",
            "signType": 2,
            "pid": null,
            "signLevel": null,
            "signHot": null
          },
          {
            "id": 0,
            "signName": "不限",
            "signType": 2,
            "pid": null,
            "signLevel": null,
            "signHot": null
          }
        ],
        configList: [],
        projectPricemonth: '',
        // 页面内权限
        auths: []
      }
    },
    mounted() {
      this.getData()
      this.getAuth()
    },
    methods: {
      getData() {
        this.$http({
          method: "POST",
          url: '/rest/webCondition/findAllMaster'
        }).then(res => {
          this.tableData = res.data
          res.data.map(item => {
            if (item.id === 15) {
              this.projectPricemonth = item.month
            }
          })
        })

        this.$http({
          method: "POST",
          url: '/rest/webCondition/findCrmSingName'
        }).then(res => {
          // this.signNameList = res.data
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })

        this.$http({
          method: "POST",
          url: '/rest/webCondition/findCrmWebCondition'
        }).then(res => {
          this.configList = res.data
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })
      },
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 24,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          let data = res.data
          data.forEach(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })
      },
      check(handle, conditionId, postId, webId) {
        if(this.auths.indexOf(2) > -1){
          if (handle === 'remove') {
            this.configList.forEach((item, index, arr) => {
              if (item.conditionId === conditionId && item.postId === postId && item.webId === webId) {
                if (item.id == null) {
                  arr.splice(index, 1)
                } else {
                  item.postId = ''
                }
              }
            })
          } else if (handle === 'add') {
            this.configList.push({
              id: null,
              conditionId: conditionId,
              postId: postId,
              webId: webId
            })
          }
        }
      },
      save() {
        this.configList.forEach(item => {
          item.projectPricemonth = this.projectPricemonth
        })
        this.$http({
          method: "POST",
          url: '/rest/webCondition/saveCrmWebCondition',
          data: this.configList
        }).then(res => {
          this.getData()
          utils.myNotify(this,'success','保存成功！')
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .filterTable {
    .checked {
      background-color: #e2e7fb;
      color: #8299dc;
      font-size: 13px;
    }
    .disabled {
      background-color: #f4f4f4;
      color: #aeaeae;
      font-size: 13px;
    }
    .default {
      font-size: 13px;
    }
  }

  .save-button {
    text-align: center;
    margin: 20px 0 10px;
  }
</style>




// WEBPACK FOOTER //
// src/views/filterSetting/filterSetting.vue